<script>
/**
 * Sales Analytics component
 */
export default {
  props: {
    chartType: {
      type: String,
      default: 'donut',
    },
  },
 
  data() {
    return {
      
      series: [],
      chartOptions: {
        chart: {
          height: 230,
          type: this.chartType,
        },
        labels: [],
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        colors: [
          '#1cbb8c',
          '#eeb902',
          '#ca03fc',
          '#5664d2',
          '#f63e3e',
          '#03d3fc',
          '#fc6f03',
          '#b2c8d9',
          '#c969be',
          '#03ffc4',
        ],
        tooltip: {
          y: {
            formatter: function(value) {
              let Number = value
              Number += ''
              Number = Number.replace(',', '')
              const x = Number.split('.')
              let y = x[0]
              const z = x.length > 1 ? '.' + x[1] : ''
              const rgx = /(\d+)(\d{3})/
              while (rgx.test(y)) y = y.replace(rgx, '$1' + ',' + '$2')
              return y + z + ' تومان'
            },
          },
        },
      },
    }
  },
  computed: {
    total() {
      if (this.series.length > 0) {
        if (this.chartType == 'donut') {
          const reducer = (accumulator, curr) => accumulator + curr
          return this.series.reduce(reducer)
        } else {
          if (this.series[0].data && this.series[0].data.length > 0) {
            const reducer = (accumulator, curr) => accumulator + curr
            return this.series[0].data.reduce(reducer)
          } else {
            return 0
          }
        }
      } else {
        return 0
      }
    },
  },
  mounted() {
    if (this.chartType == 'donut') {
      this.chartOptions.plotOptions = {
        pie: {
          donut: {
            size: '75%',
          },
        },
      }
    } else {
      this.chartOptions.plotOptions = {
        bar: {
          horizontal: false,
          columnWidth: '10px',
          endingShape: 'rounded',
          borderRadius: 10,
        },
      }
    }
    this.fetchData()
  },
  methods: {
    price(value) {
      return this.$helper.formatPrice(value)
    },
    fetchData() {
      this.$axios.get('income/group-by-application').then((res) => {
        if (this.chartType == 'donut') {
          this.series = res.data.data
        } else {
          this.series = [
            {
              name: 'درآمد',
              data: res.data.data,
            },
          ]
        }
        this.chartOptions.labels = res.data.labels
      })
    },
  },
}
</script>

<template>
  <div class="card">
    <div class="card-body">
      <h4 class="card-title mb-4">
        درآمد اپلیکیشن ها - {{ $helper.formatPrice(total) }} تومان
      </h4>
      <div id="donut-chart" class="apex-charts"></div>
      <apexchart
        v-if="chartOptions.labels.length > 0"
        class="apex-charts"
        height="230"
        dir="rtl"
        :series="series"
        :options="chartOptions"
      ></apexchart>
      <div
        v-if="chartOptions.labels.length > 0 && chartType == 'donut'"
        class="row flex justify-content-center align-items-center flex-wrap"
      >
        <div class="mx-2" :key="i" v-for="(item, i) in series">
          <div class="text-center mt-4">
            <p class="mb-2">
              <i
                class="mdi mdi-circle font-size-10 mr-1"
                :style="{ color: chartOptions.colors[i] }"
              ></i>
              {{ chartOptions.labels[i] }}
            </p>
            <h5>{{ ((item * 100) / total).toFixed(2) }}%</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
